<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('orders.destination')"
    class="search-filter"
    optional
  >
    <LocationFilter
      :id="inputId"
      v-model="destination"
      :placeholder="t('orders.destination')"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { LocationFilters } from '@/model';
import { ShipOrderSearchCriteria } from '@/model/consolidation';

import LocationFilter from '@/components/search/LocationFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipOrderSearchCriteria,
    default: () => new ShipOrderSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipOrderSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipOrderSearchCriteria>) =>
    new ShipOrderSearchCriteria(opts),
});

const destination = computed({
  get() {
    return new LocationFilters({
      locationId: internalValue.value.destinationLocationId,
      locationCode: internalValue.value.destinationLocationCode,
      locationName: internalValue.value.destinationLocationName,
      city: internalValue.value.destinationCity,
      state: internalValue.value.destinationState,
      postalCode: internalValue.value.destinationPostalCode,
      country: internalValue.value.destinationCountry,
    });
  },
  set(newVal: LocationFilters) {
    internalValue.value.destinationLocationId = newVal.locationId;
    internalValue.value.destinationLocationCode = newVal.locationCode;
    internalValue.value.destinationLocationName = newVal.locationName;
    internalValue.value.destinationCity = newVal.city;
    internalValue.value.destinationState = newVal.state;
    internalValue.value.destinationPostalCode = newVal.postalCode;
    internalValue.value.destinationCountry = newVal.country;
  },
});
</script>
